import type { ParticipationPromptPublic, ParticipationStats } from "@tih/shared";
import { TestimonialForm } from "../forms/TestimonialForm";
import { ParticipationOpenTextForm } from "./ParticipationOpenTextForm";
import { ParticipationYesNoForm } from "./ParticipationYesNoForm";
import { ParticipationPastoralForm } from "./ParticipationPastoralForm";
import { ParticipationRsvpAction } from "./ParticipationRsvpAction";
import { ParticipationInviteAction } from "./ParticipationInviteAction";
import { EventPrepChecklist } from "./EventPrepChecklist";
import type { PrepChecklistItem } from "@tih/shared";

type Props = {
  prompt: ParticipationPromptPublic;
  stats: ParticipationStats | null;
  registeredSeats: number;
  prepChecklist: PrepChecklistItem[];
  eventId: number | null;
  onUpdate: () => void;
};

export function ParticipationPromptContent({
  prompt,
  stats,
  registeredSeats,
  prepChecklist,
  eventId,
  onUpdate,
}: Props) {
  switch (prompt.kind) {
    case "OPEN_TEXT":
      return <ParticipationOpenTextForm prompt={prompt} onSuccess={onUpdate} />;
    case "YES_NO":
      return <ParticipationYesNoForm prompt={prompt} stats={stats} onAnswer={onUpdate} />;
    case "PASTORAL":
      return <ParticipationPastoralForm prompt={prompt} onSuccess={onUpdate} />;
    case "TESTIMONIAL":
      return <TestimonialForm onSuccess={onUpdate} />;
    case "ACTION_RSVP":
      return (
        <ParticipationRsvpAction
          prompt={prompt}
          registeredSeats={registeredSeats}
          onUpdate={onUpdate}
        />
      );
    case "ACTION_INVITE":
      return <ParticipationInviteAction prompt={prompt} onShared={onUpdate} />;
    case "ACTION_PREP":
      return eventId != null ? (
        <EventPrepChecklist eventId={eventId} items={prepChecklist} />
      ) : (
        <p style={{ opacity: 0.75 }}>An upcoming event is required for the prep checklist.</p>
      );
    default:
      return null;
  }
}
